import { Box, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EventIcon from "@mui/icons-material/Event";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import {
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getStartOfMonth,
} from "../utils/commonUtils";

export const ToFromDate = ({ startDateFormat, update, setstartDateFormat, endDate, setEndDate }) => {
  const datePickerRef1 = useRef();
  const datePickerRef2 = useRef();
  const [date, setDate] = useState(""); // Empty string initially
  const [displayEndDate, setDisplayEndDate] = useState(""); // Empty string initially
  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [isNothing, setIsNothing] = useState(false);
  useEffect(()=>{
    console.log("getFirstDateOfCurrentMonthPayloadFormate ",update ," ",startDateFormat)
    if( update){
  
    setIsNothing(true)
  }
   
   },[update ])
  // Open the start date picker
  const openStartDatePicker = () => {
    if (datePickerRef1.current) {
      datePickerRef1.current.setOpen(true);
    }
  };

  // Open the end date picker after start date selection
  const openEndDatePicker = () => {
    if (datePickerRef2.current) {
      datePickerRef2.current.setOpen(true);
    }
  };

  // Handle start date selection
  const datePickerOnChange = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const formattedDate = dateStr.split("/").reverse().join("-");
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    let formattedDate2 = dateStr2.split(" ").reverse().join("-");
    setDate(formattedDate2);
    setstartDateFormat(formattedDate);
    setSelectedStartDate(date);
    // setIsNothing(true);
    
    // Automatically open the end date picker after start date selection
    openEndDatePicker();
  };

  // Handle end date selection
  const datePickerOnChangeEnd = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const formattedDate = dateStr.split("/").reverse().join("-");
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    let formattedDate2 = dateStr2.split(" ").reverse().join("-");
    setDisplayEndDate(formattedDate2);
    setEndDate(formattedDate);
    setSelectedEndDate(date);

    // datePickerRef2.current.setOpen(false);

  };

  useEffect(() => {
    if (startDateFormat && getFirstDateOfCurrentMonthPayloadFormate() !== startDateFormat) {
      const parsedDate = new Date(startDateFormat);
      if (!isNaN(parsedDate)) {
        datePickerOnChange(parsedDate);
      }
    }
    if (endDate && getFirstDateOfCurrentMonthPayloadFormate() !== endDate) {
      const parsedDate = new Date(endDate);
      if (!isNaN(parsedDate)) {
        datePickerOnChangeEnd(parsedDate);
      }
    }
  }, [startDateFormat, endDate]);

  useEffect(()=>{
    datePickerRef2?.current?.setOpen(false);

  },[endDate])
  return (
    <>
      <TextField
        fullWidth
        readOnly
        onClick={(e)=>{
          setIsNothing(true)
          openStartDatePicker(e)}} // Open start date picker when clicked
        id="date"
        sx={{
          mt: 2,
          "& .MuiInputBase-root": { height: "45px" },
        }}
        value={isNothing ? (date && displayEndDate ? date + " To " + displayEndDate : "") : ""}
        label={
          <Box
            sx={{
              flex: 4,
              color: "grey",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            Date :
          </Box>
        }
        onChange={() => {}}
        InputProps={{
          endAdornment: (
            <EventIcon
              sx={{
                color: (theme) => theme.palette.primary.main,
                cursor: "pointer",
              }}
            />
          ),
        }}
      />

      <DatePicker
        hidden={true}
        selected={SelectedStartDate}
        onChange={datePickerOnChange}
        className="custom-datepicker"
        ref={datePickerRef1}
        onClickOutside={() => {
          datePickerRef1.current.setOpen(false);
        }}
      />

      <DatePicker
        hidden={true}
        selected={SelectedEndDate}
        onChange={datePickerOnChangeEnd}
        className="custom-datepicker"
        ref={datePickerRef2}
        onClickOutside={() => {
          datePickerRef2.current.setOpen(false);
        }}
      />
    </>
  );
};
